'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tr_TR = require('../locale/tr_TR');

var _tr_TR2 = _interopRequireDefault(_tr_TR);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _tr_TR2['default'];